"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TRIP_TYPES = exports.TRIGGERS = exports.TRANSLATIONS = exports.TEXT_TYPE = exports.TEXT = exports.ICON = exports.FONT_SIZE = exports.COLORS = void 0;
var TRIP_TYPES = {
  roundtrip: 'roundtrip',
  oneway: 'oneway',
  multicity: 'multicity'
};
exports.TRIP_TYPES = TRIP_TYPES;
var TRANSLATIONS = {
  stopAt: '{0} stop at {1}',
  hour: 'h',
  minute: 'm',
  depart: 'Depart: ',
  return: 'Return: ',
  operatedBy: 'Operated by',
  subjectToGovtApproval: 'Flight is subject to obtaining government approval',
  selfTransferRequired: 'Self-transfer required'
};
exports.TRANSLATIONS = TRANSLATIONS;
var TRIGGERS = {
  hover: 'hover',
  click: 'click',
  focus: 'focus'
};
exports.TRIGGERS = TRIGGERS;
var COLORS = {
  yellow: 'yellow',
  greyDark: 'greyDark',
  greenLight: 'greenLight',
  green: 'green',
  primaryLight: 'primaryLight',
  primaryDark: 'primaryDark',
  blue: 'blue'
};
exports.COLORS = COLORS;
var TEXT_TYPE = {
  small: 'small'
};
exports.TEXT_TYPE = TEXT_TYPE;
var TEXT = {
  flightInfo: 'New Flight',
  rescheduled: 'RESCHEDULED'
};
exports.TEXT = TEXT;
var FONT_SIZE = {
  titleSmall: 'titleSmall'
};
exports.FONT_SIZE = FONT_SIZE;
var ICON = {
  warning: 'Warning'
};
exports.ICON = ICON;